import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { VeroButton } from "./VeroButton";
import { IMAGES } from "../../constants/images";

const COLS = [
  [
    { src: IMAGES.gallery_lobby, h: "h-[300px] md:h-[380px]" },
    { src: IMAGES.gallery_shoes, h: "h-[420px] md:h-[520px]" },
    { src: IMAGES.founder_portrait, h: "h-[340px] md:h-[420px]" },
    { src: IMAGES.class_energy, h: "h-[280px] md:h-[340px]" },
  ],
  [
    { src: IMAGES.bike_detail, h: "h-[440px] md:h-[560px]" },
    { src: IMAGES.sprint_energy, h: "h-[280px] md:h-[340px]" },
    { src: IMAGES.gallery_lights, h: "h-[420px] md:h-[520px]" },
    { src: IMAGES.gallery_hands, h: "h-[320px] md:h-[400px]" },
  ],
  [
    { src: IMAGES.rider_silhouette, h: "h-[400px] md:h-[500px]" },
    { src: IMAGES.hero_studio, h: "h-[280px] md:h-[340px]" },
    { src: IMAGES.detail_towel, h: "h-[440px] md:h-[540px]" },
    { src: IMAGES.instructor_podium, h: "h-[340px] md:h-[420px]" },
  ],
];

const SPEEDS = [40, 120, 70];

const Column = ({ items, speed, progress, ci }) => {
  const y = useTransform(progress, [0, 1], [speed, -speed]);
  return (
    <motion.div style={{ y }} className="space-y-8 md:space-y-10">
      {items.map((item, i) => (
        <motion.figure
          key={i}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-30px" }}
          transition={{ duration: 0.9, delay: ci * 0.08, ease: [0.22, 1, 0.36, 1] }}
        >
          <img src={item.src} alt={`Apex studio ${ci}-${i}`} className={`w-full ${item.h} object-cover`} />
          <figcaption className="mt-2.5 font-serif italic text-sm text-zinc-500">Apex</figcaption>
        </motion.figure>
      ))}
    </motion.div>
  );
};

export const MediaGridSection = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });

  return (
    <section id="studio" className="px-6 md:px-14 py-16 md:py-24" data-testid="media-grid-section">
      <div ref={ref} className="relative grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        {COLS.map((items, ci) => (
          <Column key={ci} items={items} speed={SPEEDS[ci]} progress={scrollYProgress} ci={ci} />
        ))}
      </div>
      <div className="mt-24 text-center">
        <VeroButton text={t.grid.cta} to="/book" testId="grid-cta-btn" />
      </div>
    </section>
  );
};
